// extracted by mini-css-extract-plugin
module.exports = {"container":"errorPage_container__zArjJ","content":"errorPage_content__a4pdt","illustration":"errorPage_illustration__Su5fZ","title":"errorPage_title__JmcE6"};